import React, { useContext, useState, useEffect } from 'react'
import { supabase } from '../components/auth/supabaseClient'


const AuthContext = React.createContext()

export function AuthProvider({ children }) {
    const [user, setUser] = useState()
    const [loading, setLoading] = useState(true)
    const [session, setSession] = useState(null)

    useEffect(() => {
        // Check active sessions and sets the user
        // const session = supabase.auth.getSession()

        // console.log(session)

        supabase.auth.getSession().then(({ data: { session } }) => {
            // setSession(session)
            setUser(session?.user ?? null)
            setSession(session)
        })

        setUser(session?.user ?? null)
        setLoading(false)

        // Listen for changes on auth state (logged in, signed out, etc.)
        const { data: listener } = supabase.auth.onAuthStateChange(
            async (event, session) => {
                setUser(session?.user ?? null)
                setLoading(false)
            }
        )

        return () => {
            listener?.unsubscribe()
        }
    }, [])

    // Will be passed down to Signup, Login and Dashboard components
    const value = {
        signUp: (data) => supabase.auth.signUp(data),
        signIn: (data) => supabase.auth.signIn(data),
        signOut: () => supabase.auth.signOut(),
        updateUserMetadata: (data) => supabase.auth.updateUser(data),
        user,
        loading
    }

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    return useContext(AuthContext)
}